export default "/images/no-photo.png?ce4ec3602b5ea306ff24595aa7200172";